import {useCallback, useState} from 'react';

const useActionDrawer = (toggled = false) => {
  const [actionDrawerToggled, setActionDrawerToggled] = useState(toggled)
  const toggleActionDrawer = useCallback(() => setActionDrawerToggled(!actionDrawerToggled), [actionDrawerToggled])
  return [actionDrawerToggled, toggleActionDrawer]
}

export default useActionDrawer
